// extracted by mini-css-extract-plugin
export var container = "_51-0";
export var error = "_51-9";
export var label = "_51-5";
export var light = "_51-6";
export var md = "_51-3";
export var sm = "_51-2";
export var thin = "_51-8";
export var thinBold = "_51-7";
export var vertical = "_51-4";
export var xs = "_51-1";